import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { inspectionService } from '../services/inspection.service';
import type { InspectionVerification, ReturnVerificationInput } from '../types/inspection.types';
import { INSPECTION_QUERY_KEY } from './useVerificationsForInspection';

export function useReturnVerification(): {
  returnVerification: UseMutateFunction<InspectionVerification, Error, ReturnVerificationInput>;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: Error | null;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (input: ReturnVerificationInput) =>
      inspectionService.returnVerification(input.verificationId, input.comment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: INSPECTION_QUERY_KEY });
    },
  });

  return {
    returnVerification: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  };
}
